<script lang="ts">
  export type BtnSignOutProps = Omit<GatButtonProps, 'onClick'> & {
    showTooltip?: boolean
  }
</script>

<script setup lang="ts">
  import { type GatButtonProps } from '@gat-ship/vue-components'
  import { useAuth0 } from '@gat-ship/lib/auth'
  import {
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipContent
  } from '@gat-ship/vue-components/tooltip'
  const props = withDefaults(defineProps<BtnSignOutProps>(), {
    label: 'Sign out',
    icon: 'LogOut'
  })
  const { logout } = useAuth0()
</script>
<template>
  <tooltip-provider>
    <tooltip :disabled="!props.showTooltip">
      <tooltip-trigger as-child>
        <gat-button v-bind="props" @click="logout()" />
      </tooltip-trigger>
      <tooltip-content>
        <div>Sign out</div>
      </tooltip-content>
    </tooltip>
  </tooltip-provider>
</template>
